var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { OperationRecordsRepository } from '../repositories/operation-records-repository.interface';
let OperationRecordsServiceImpl = class OperationRecordsServiceImpl {
    constructor(_operationRecordsRepository) {
        this._operationRecordsRepository = _operationRecordsRepository;
    }
    getOperationRecords(params) {
        return this._operationRecordsRepository.getOperationRecords(params);
    }
    getSpecialQueryOriginalText(params) {
        return this._operationRecordsRepository.getSpecialQueryOriginalText(params);
    }
};
OperationRecordsServiceImpl = __decorate([
    injectable(),
    __param(0, inject(OperationRecordsRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof OperationRecordsRepository !== "undefined" && OperationRecordsRepository) === "function" ? _a : Object])
], OperationRecordsServiceImpl);
export { OperationRecordsServiceImpl };
